// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MVb7","input":"styles_input__1AslT"};